import { render } from "./PracticeWordList.vue?vue&type=template&id=5ccec704&scoped=true"
import script from "./PracticeWordList.vue?vue&type=script&lang=ts"
export * from "./PracticeWordList.vue?vue&type=script&lang=ts"

import "./PracticeWordList.vue?vue&type=style&index=0&id=5ccec704&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ccec704"

export default script